<div class="environment">{{ environmentName }}</div>
<app-top-level-menu [class.show]="menuService.showTopLevelMenu()"></app-top-level-menu>
<div class="version">Versie: {{ version }}</div>
<div class="account">
	<span>{{ account$ | async }}</span>
	@if (authService.developer()) {
		<app-icon name="crown" color="typography-4"></app-icon>
	}
</div>
